import { Grid } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomRadio from 'components/CustomRadio';
import { SEvenRow } from 'style/CommonStyledComponent';

const RemedialActions = ({
    classes,
    remoteDetail,
    updateRemoteDetail,
    isViewOnly,
    forceErrorDisplay,
    setAffectedSubjectValid,
    setAlterationRequiredValid,
    setRecommendationValid,
}) => {
    const changeAffected = (key, checked) => {
        updateRemoteDetail(key, checked ? true : null);
    };
    const getAffectedSubject = () => {
        let affectedSubject = [];
        if (remoteDetail.affectedSubjectNone) {
            affectedSubject.push('affectedSubjectNone');
        }
        if (remoteDetail.affectedSubjectAdjustedDosage) {
            affectedSubject.push('affectedSubjectAdjustedDosage');
        }
        if (remoteDetail.affectedSubjectInterrupt) {
            affectedSubject.push('affectedSubjectInterrupt');
        }
        if (remoteDetail.affectedSubjectDiscontinued) {
            affectedSubject.push('affectedSubjectDiscontinued');
        }
        return affectedSubject;
    };

    return (
        <>
            <Grid container className={classes.subItem}>
                <SEvenRow style={{ marginTop: 10 }} labelWidth={200}>
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            On the affected subject:
                        </div>
                        <div>
                            <CustomCheckbox
                                isRequired
                                forceErrorDisplay={forceErrorDisplay}
                                isValidValue={(isValid) => setAffectedSubjectValid(isValid)}
                                disabled={isViewOnly}
                                allowUnCheckAll
                                onItemChange={changeAffected}
                                value={getAffectedSubject()}
                                defaultData={[
                                    {
                                        key: 'affectedSubjectNone',
                                        display: 'None',
                                    },
                                    {
                                        key: 'affectedSubjectAdjustedDosage',
                                        display: 'Adjusted dosage',
                                    },
                                    {
                                        key: 'affectedSubjectInterrupt',
                                        display: 'Interrupted temporarily',
                                    },
                                    {
                                        key: 'affectedSubjectDiscontinued',
                                        display: 'Discontinued / terminated study',
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </SEvenRow>

                <SEvenRow style={{ marginTop: 20 }} labelWidth={200}>
                    <div>
                        <div style={{
                        }}>
                            For all subjects / study design:
                        </div>
                        <div>
                            <div>
                                Alteration of protocol required?
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <CustomRadio
                                    isRequired
                                    forceErrorDisplay={forceErrorDisplay}
                                    isValidValue={(isValid) => setAlterationRequiredValid(isValid)}
                                    disabled={isViewOnly}
                                    onChange={(e) => {
                                        updateRemoteDetail('alterationRequired', e.target.value === 'true');
                                    }}
                                    value={remoteDetail.alterationRequired}
                                    operators={[
                                        {
                                            key: true,
                                            label: 'Yes',
                                        },
                                        {
                                            key: false,
                                            label: 'No',
                                        },
                                    ]}
                                />
                            </div>
                            <div style={{
                                marginTop: 20,
                            }}>
                                Any recommendation from the Data Monitoring Committee?
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <CustomRadio
                                    isRequired
                                    forceErrorDisplay={forceErrorDisplay}
                                    isValidValue={(isValid) => setRecommendationValid(isValid)}
                                    disabled={isViewOnly}
                                    onChange={(e) => {
                                        updateRemoteDetail('recommendation', e.target.value === 'true');
                                    }}
                                    value={remoteDetail.recommendation}
                                    operators={[
                                        {
                                            key: true,
                                            label: 'Yes',
                                        },
                                        {
                                            key: false,
                                            label: 'No',
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </SEvenRow>
            </Grid>
        </>
    );
};
export default RemedialActions;
